export type HideWatchedType = 'hide_watched' | 'hide_watched_channel' | 'hide_watched_playlist';

export const HideWatchedName = {
  Home: 'hide_watched',
  Channel: 'hide_watched_channel',
  Playlist: 'hide_watched_playlist',
};
